import Emitter from '../../services/emitter';
import { trackEvent } from '../../util/analytics';

Emitter.on('LogConnectDevice', (device, isOk, connectType) => {
    if (device && device.name) {
        trackEvent(device.name, `connect_${isOk ? 'ok' : 'fail'}`, { el: connectType });
    }
});

Emitter.on('LogDisconnectDevice', (device, dm) => {
    if (device && device.name) {
        trackEvent(device.name, 'disconnect', { el: dm });
    }
});

Emitter.on('LogUploadCode', (deviceId, isOk, status) => {
    if (deviceId) {
        trackEvent(deviceId, `upload_code_${isOk ? 'ok' : 'fail'}`, { el: status });
    }
});

Emitter.on('LogUpdateFirmware', (device, isOk, status) => {
    if (device && device.name) {
        trackEvent(device.name, `update_firmware_${isOk ? 'ok' : 'fail'}`, { el: status });
    }
});

Emitter.on('LogMblockUpdate', (isOk) => {
    let action = 'update_mblock';
    if (isOk !== undefined) {
        action += (isOk ? '_ok' : '_fail');
    }
    trackEvent('mblock', action);
});

Emitter.on('LogExtension', (extensionName, isLoad) => {
    trackEvent('extension', `${isLoad ? 'load' : 'unload'}`, { el: extensionName });
});

Emitter.on('LogTutorial', (stauts, seryId, lessonId) => {
    trackEvent('tutorial', `${stauts ? 'lessson_start' : 'lessson_finish'}`, { el: `${seryId}-${lessonId}` });
});